import * as segmentSnippet from "@segment/snippet";
import { withGpcGuard } from "./gpc";

export const renderSegmentSnippet = (
  apiKey = process.env.NEXT_PUBLIC_LADDER_QUIZ_SEGMENT_WRITE_KEY
) => {
  const opts = {
    apiKey,
    // note: the page option only covers SSR tracking.
    // Page.js is used to track other events using `window.analytics.page()`
    page: false,
    // Enable batching to reduce dropped events on page navigation
    // Events are batched and sent together, with flush on beforeunload using keepalive
    // See: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#batching
    load: {
      integrations: {
        "Segment.io": {
          deliveryStrategy: {
            strategy: "batching",
            config: {
              size: 10, // batch after 10 events
              timeout: 5000, // OR flush after 5 seconds (whichever comes first)
            },
          },
        },
      },
    },
  };

  const snippet =
    process.env.NEXT_PUBLIC_ENVIRONMENT !== "production"
      ? segmentSnippet.max(opts)
      : segmentSnippet.min(opts);

  return withGpcGuard(snippet);
};
